/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryAssignedTo extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryAssignedTo");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryAssignedTo.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryAssignedTo>): AssessmentViewQueryAssignedTo {
        let obj = Object.assign(new AssessmentViewQueryAssignedTo(), model);
        AssessmentViewQueryAssignedTo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryAssignedTo>): AssessmentViewQueryAssignedTo {
        if (!model) return null;
        return AssessmentViewQueryAssignedTo.newInstance(<AssessmentViewQueryAssignedTo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryAssignedTo) {
        if (!obj) return;

        models.AssessmentViewQueryAssignedTo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryAssignedTo): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryAssignedTo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User ID to whom the question is assigned to
     */
    assigned_to: Array<string>;

}
